// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n2-1";
export var messageSideRight = "_n2-2";
export var orderLookupBubbleContainer = "_n2-0";
export var submitButton = "_n2-3";